import * as React from 'react';
import { LazyLoader } from '../LazyLoader/LazyLoader';
import { IMAGE_TEST_ID } from './Image.const';

export interface IImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  alt?: string;
  offset?: number;
  src?: string;
  className?: string;
  dataAssetId?: string;
  isLazyLoad?: boolean;
}

export const Image = React.forwardRef<HTMLImageElement, IImageProps>(
  ({ className, alt, offset, src, isLazyLoad = true, dataAssetId, ...props }, ref) => {
    const dataAssetIDAttr = dataAssetId && { 'data-asset-id': dataAssetId };
    const image = (
      <img
        className={className}
        alt={alt}
        src={src}
        ref={ref}
        data-testid={IMAGE_TEST_ID.image}
        data-loading="lazy"
        {...dataAssetIDAttr}
        {...props}
      />
    );
    return isLazyLoad ? <LazyLoader offset={offset}>{image}</LazyLoader> : image;
  },
);

Image.displayName = 'Image';
